<template>
  <div class="add-form">
    <div class="pagination-container">
      <el-button size="small"
                 @click="goAdd">
        新建用户
      </el-button>

      <el-pagination class="pagination-right"
                     :current-page="query.page"
                     :page-sizes="[10, 20, 50, 100, 500, 1000]"
                     :page-size="query.per_page"
                     :pager-count="5"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="totalCount"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange" />
    </div>
    <el-table :data="list"
              style="width: 100%">
      <el-table-column prop="realname"
                       label="姓名" />
      <el-table-column prop="name"
                       label="用户名" />
      <el-table-column prop="phone"
                       label="手机号"
                       width="170px" />
      <el-table-column prop="auth_groups"
                       label="所属权限组">
        <template slot-scope="scope">
          <span v-for="(group, gi) in scope.row.auth_groups"
                :key="gi">
            {{ group.name
            }}<template v-if="gi < scope.row.auth_groups.length - 1">,</template>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="department"
                       label="所属人事组" />
      <el-table-column prop="user_groups"
                       label="所属用户组" />
      <el-table-column label="操作"
                       width="100px">
        <template slot-scope="scope">
          <!--<el-button @click="goDetail(scope.row)" type="text" size="small">查看</el-button>-->
          <el-button v-if="scope.row.email != 'developer'"
                     type="text"
                     size="small"
                     @click="goAdd(scope.row)">
            编辑
          </el-button>
          <el-button v-if="scope.row.email != 'developer'"
                     type="text"
                     size="small"
                     @click="onDelete(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { queryUser, deleteUser } from '@/api/admin';

export default {
  props: {
    params: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      pageRouter: 'list',
      query: {
        page: 1,
        per_page: 10,
      },
      totalCount: 0,
      list: null,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      let params = Object.assign({}, this.query);
      console.log(params);
      params = Object.keys(this.params || {}).reduce((t, c) => {
        if (this.params[c]) {
          t[c] = this.params[c];
        }
        return t;
      }, params);
      Object.keys(params).forEach((p) => {
        if (!params[p] && params[p] !== 0) {
          delete params[p];
        }
      });
      queryUser(params).then((res) => {
        this.list = res.data.users;
        this.totalCount = res.data.total;
        // 如果分页条件大于总数了，再查询一次
        if (this.query.page > 1 && (this.query.page - 1) * this.query.per_page >= this.totalCount) {
          this.query.page -= 1;
          this.fetchData();
        }
      });
    },
    onSubmit() { },
    onDelete(item) {
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deleteUser({ id: item.id }).then((res) => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            this.fetchData();
            this.$store.dispatch('GetInfo');
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    handleSizeChange(val) {
      this.query.page = 1;
      this.query.per_page = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.fetchData();
    },
    goAdd(item) {
      this.$emit('setRPQ', { r: 'add', p: item ? item.id : undefined });
    },
    goDetail(item) {
      this.$emit('setRPQ', { r: 'detail', p: item.id });
    },
  },
};
</script>
